export default {
    id: "fc7e1947-2d23-42e6-8946-7526a41e641b",
    icon: "mdi-bullseye-arrow",
    name: "objectives",
    title: "Objectives",
    description: "A carrousel showing all objectives in the Lesson Plan",
}